<template>
  <el-dialog
    :visible.sync="dialogMsg.dialogTab"
    width="30%"
    :before-close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-upload
          v-if="percentageFile==0"
          class="logoImg"
          :action="uploadUrl"
          list-type="picture-card"
          accept=".png,.PNG,.jpg,.JPG,.jpeg"
          :http-request="uploadLogoFile"
          :show-file-list="false"
          :auto-upload="true"
        >
          <img v-if="addMsg.image" :src="addMsg.image" class="upload-image" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="process" v-if="percentageFile!=0">
            <el-progress
              type="circle"
              :width = 100
              :percentage="this.percentageFile"
            ></el-progress>
          </div>
        <el-input v-model="addMsg.image"></el-input>
        
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-input v-model="addMsg.name" placeholder="输入中文标题"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-input
          v-model="addMsg.englishName"
          placeholder="输入英文标题"
        ></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-input v-model="addMsg.source" placeholder="输入链接网址"></el-input>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addTabsBack">取 消</el-button>
      <el-button
        type="primary"
        v-if="dialogMsg.kind != 'update'"
        @click="addTabsOK"
        >添 加</el-button
      >
      <el-button
        type="primary"
        v-if="dialogMsg.kind == 'update'"
        @click="addTabsOK"
        >修 改</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: { dialogMsg: Object, dialogItem: Object },
  data() {
    return {
      uploadUrl: "",
      addMsg: {},
      scholarData: [],
      percentageFile:0,
    };
  },
  mounted() {},
  watch: {
    dialogItem(val, oldVal) {
   this.addMsg = JSON.parse(JSON.stringify(val))
    },
  },
  methods: {
    // 上传头像
    uploadLogoFile(params) {
      // this.$global.uploadImage(this, params).then((res) => {
      //   this.$set(this.addMsg,"image",res.split("?")[0])
      //   console.log(this.addMsg.image);
      // });
      // console.dir(params.file.name);
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.percentageFile = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.$set(this.addMsg,"image",res.url.split("?")[0])
        this.percentageFile=0
      });
    },
    // 测试
    handleClose() {
      this.$emit("addTabsBack");
     
    },
    addTabsBack() {
      this.$emit("addTabsBack");
      this.addMsg={}
   
    },
    addTabsOK() {
      this.$emit("addTabsOK", this.addMsg);
      this.addMsg={}
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  display: flex;
  justify-content: center;
  .el-col-18 {
    display: flex;
    h4 {
      width: 40px;
      align-self: center;
      font-size: 16px;
      color: $keywords;
      margin-right: 40px;
    }
  }
  .el-col {
    margin-bottom: 16px;
  }
}
.process {
  width: 200px;
  height: 130px;
  text-align: center;
}
/deep/ .el-upload--picture-card {
  width: 200px;
  height: 130px;
  img {
    width: 200px;
    height: 130px;
    object-fit: contain;
  }
}
/deep/ .el-dialog__body{padding: 30px;}
.el-dialog__footer {
    padding: 10px 25% 20px;
    .dialog-footer {
      height: 28px;
      display: flex;
      justify-content: center;
      .el-button--default:hover {
        background: $base-color;
        color: $blueBtna;
      }
      .el-button--default {
        border-radius: 100px;
        border: 1px solid $schoolTagBorder;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $schoolTagColor;
        }
      }
      .el-button--primary {
        border-radius: 100px;
        background: $pageViewSmall;
        border: 1px solid $pageViewSmall;
        padding: 4px 24px;
        span {
          font-size: 12px;
          color: $base-color;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/exploration/components/DialogTabs.vue